export default "__VITE_ASSET__CPvjsovY__"